(function bcIceDistrictOverrides() {
    var BLANK = 'blank';

    document.addEventListener('tbyb_cart_update', initBoldOptionsListener, { once: true });
    // Quick Buy integration
    document.addEventListener('quickview:loaded', function() {
        if (!tbyb || !tbyb.productManager) {
            return;
        }
        tbyb.productManager.getProducts();
    });

    function initBoldOptionsListener() {
        var boldOptionSet = document.querySelector('.bold_option_set');
        if (!boldOptionSet) {
            return;
        }
        boldOptionSet.addEventListener('change', function disableTBYBButtonOnNonBlankOption(event) {
            if (event.target.type !== 'radio') {
                return;
            }
            if (event.target.value.toLowerCase() === BLANK) {
                revealNode(tbybButton());
            } else {
                hideNode(tbybButton());
            }
        })
    }

    function tbybButton() {
        return document.querySelector('[data-tbyb="tbyb-button"]');
    }
    
    function hideNode(node) {
        node.style.display = 'none';
    }

    function revealNode(node)  {
        node.style.display = 'revert';
    }
})();

document.addEventListener("tbyb_cart_update", function () {
  var isCartQualified = window.tbyb.validator.isQualified;

  document
    .querySelectorAll(
      ".sezzle-shopify-info-button, .cart_savings.sale, .additional-checkout-buttons"
    )
    .forEach(hideSectionIfCartQualified);

  function hideSectionIfCartQualified(node) {
    if (isCartQualified) {
      node.style.display = "none";
    } else {
      node.style.display = "revert";
    }
  }

});

// Add an event listener for the 'tbyb_cart_update' event
document.addEventListener('tbyb_cart_update', function() {
    // Select the rebuy-cart__flyout-actions container
    let container = document.querySelector('.rebuy-cart__flyout-actions');

    if (container) {
        // Within this container, select all checkout buttons using the rebuy-cart__checkout class
        let checkoutButtons = container.querySelectorAll('.rebuy-cart__checkout-button');

        // Loop through the checkout buttons
        for (let i = 0; i < checkoutButtons.length; i++) {
            if (i === 0) {
                // If it's the first button, ensure it's displayed
                checkoutButtons[i].style.display = 'block';
            } else {
                // If it's not the first button, set its display to 'none'
                checkoutButtons[i].style.display = 'none';
            }
        }
    }
});

